import React from 'react';
import PersonnelSelect, { PersonnelSelectProps } from './PersonnelSelect';

// Wrapper that fixes mode to "name_only"
export type PersonnelNameSelectProps = Omit<PersonnelSelectProps, 'mode'>;

const PersonnelNameSelect: React.FC<PersonnelNameSelectProps> = (props) => {
  return <PersonnelSelect {...props} mode="name_only" />;
};

export default PersonnelNameSelect;
